module.exports = __webpack_public_path__ + "img/premium_gold_crown.f87553d6.svg";